<template>
	<v-container class="login-container">
		<v-layout class="login_background" flex-wrap justify-center>
			<v-flex xs12>
				<div :style="`background-color: ${$store.state.PointColor1};`" style="max-width:600px; margin:0 auto; height: 100vh;" class="pt-6">
					<v-card class="waitingCheck pa-4 mb-0" elevation="0">
						<v-img style="margin: 0 auto;" src="/image/reserveCheck.png" width="92" contain></v-img>
						<div class="reserveCheck-header-text my-2">
							내 앞 대기팀을 확인하세요
						</div>
					</v-card>
					<div class="waitingCheck-dash" :style="$vuetify.breakpoint.xs ? 'max-width:85%;' : ''"></div>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-if="nowaitUser.show">
						<v-layout justify-center class="mx-4">
							<v-flex :xs12="$route.params.code === '1rbo2fsusgv'" :xs6="$route.params.code !== '1rbo2fsusgv'">
								<v-img src="/image/reserveCheckWaiting.png" width="23" height="23" contain></v-img>
								<div class="reserveCheck-text-1 pt-1">
									내 앞 입장 대기 팀
								</div>
								<div class="reserveCheck-text-2">
									<span class="impact">{{ frontnum }}</span
									>팀
								</div>
							</v-flex>
							<v-flex xs6 v-if="$route.params.code !== '1rbo2fsusgv'">
								<v-img src="/image/reserveCheckTime.png" width="23" height="23" contain></v-img>
								<div class="reserveCheck-text-1 pt-1">
									예상 대기 시간
								</div>
								<div class="reserveCheck-text-2">
									<span class="impact2">{{
										waitingMinite === 0 ? (reservedaysData.waitingTimes[30] > 10 ? 10 : reservedaysData.waitingTimes[30]) : waitingMinite
									}}</span
									>분
								</div>
							</v-flex>
						</v-layout>
						<v-layout class="mt-7 px-2" v-if="$route.params.code !== '1rbo2fsusgv'">
							<span class="mr-1" style="font-size: 13px;">※</span>
							<div class="reserveCheck-text-3 text-left">
								<span class="impact">예상 대기 시간은</span> 현재 견본주택 관람 및 상담 현황에 따라
								<span class="impact">
									실제 대기 시간과 차이가 있을 수 있습니다.
								</span>
							</div>
						</v-layout>
						<v-layout class="mt-7 px-2">
							<span class="mr-1" style="font-size: 13px;">※</span>
							<div class="reserveCheck-text-3 text-left">
								고객님의 입장순서가 되면 입장 안내 알림톡이 발송됩니다.
								<span>
									외부에서 기다려 주신 고객께서는 <span class="impact">고객님의 안전을 위하여 천천히 입장해주시기</span> 바랍니다.
								</span>
							</div>
						</v-layout>
						<div class="pt-8" v-if="$route.params.code === 'wquw7972ngs'">
							<btn :btn="closeBtn" btn_txt="오픈 리플렛 다운로드" @click="download()"></btn>
						</div>
						<div class="pt-4">
							<btn :btn="closeBtn" btn_txt="새로고침" @click="refresh()"></btn>
						</div>
					</v-card>
					<v-card class="waitingCheck mt-0 px-4 pt-8 pb-6" elevation="5" v-else>
						<v-layout class="px-2">
							<div class="reserveCheck-text-1 pt-1">
								이미 입장알림을 받은 고객입니다. <br />
								알림톡을 확인해 주세요. <br />
								<!-- or 방문등록하지 않은 고객입니다.<br />
								QR코드 배너를 통하여 방문등록 해주세요.<br /> -->
							</div>
						</v-layout>
					</v-card>

					<a class="hideClose" id="closeWaiting" onclick="window.close(); location.href = 'kakaotalk://inappbrowser/close'; return false;"
						>닫기</a
					>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { btn } from '@/components/index.js'
export default {
	components: {
		btn,
	},
	metaInfo() {
		return {
			title: '방문등록 실시간 체크',
			socket: null,
		}
	},
	mounted() {},
	data() {
		return {
			countDown: 0,
			userInfo: { name: '', cdate: '', waitingnum: '' }, // 고객 waiting 정보
			frontnum: 0, //현재 대기자 수
			waitingMinite: 0, // 예상 대기 시간
			closeBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn refreshBtn',
				color: this.$store.state.PointColor1,
			},
			nextBtn: {
				// 닫기, 상담 취소 버튼
				large: true,
				block: true,
				dark: true,
				class: 'customBtn',
				color: this.$store.state.PointColor1,
			},
			realWait: '', // 신청 유무
			nowaitUser: { show: true }, // 예약 없을 시 고객 데이터
			alertModal: {
				dialog: false,
				text: '',
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			screenWidth: window.innerWidth,
			reservedaysData: {
				waitingTimes: {
					'30': 10,
				},
			},
			socket: '',
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	async created() {
		if (this.$route.params.code === '09buhz2luv1') {
			this.$router.push({ name: 'reserveCheck', params: { code: '09buhz2luv', groupcode: '09buhz2luv' } })
		}
		await this.reservedays()
		await this.realTimeWait()
	},
	methods: {
		download() {
			const element = document.createElement('a')
			element.setAttribute('href', '/잠실 래미안아이파크 오픈 리플렛.pdf')
			element.setAttribute('download', '잠실 래미안아이파크 오픈 리플렛.pdf')
			element.click()
			document.body.removeChile(element)
		},
		async reservedays() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
			}
			await this.$store.dispatch('reservedays', data).then(res => {
				this.reservedaysData = res.data.reservedays[0]
			})
		},

		async realTimeWait() {
			const data = {
				code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
				phone: this.$route.params.phone,
				sdate:
					this.$moment()
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + ' 15:00:00',
				edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				reserveState: 'reserve',
			}
			await this.$store
				.dispatch('findReserveusers', data)
				.then(res => {
					if (res.data.reserveusers.length > 0) {
						let waitInfo = res.data.reserveusers[0]
						this.userInfo.name = waitInfo.name
						this.userInfo.cdate = this.$moment(waitInfo.updated_at).format('YYYY년 MM월 DD일 HH:mm')
						this.userInfo.waitingnum = waitInfo.waitingnum
						this.nowaitUser.show = true
						const data = {
							code: this.$route.params.code === '09buhz2luv' ? '09buhz2luv1' : this.$route.params.code,
							sdate:
								this.$moment()
									.subtract(1, 'd')
									.format('YYYY-MM-DD') + ' 15:00:00',
							edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
							reserveState: 'reserve',
							waitingnum: Number(this.userInfo.waitingnum),
						}
						this.$store.dispatch('reserveusersConnection', data).then(res => {
							this.frontnum = res.data.reserveusersConnection.aggregate.count - 1
							this.waitingMinite = this.reservedaysData.waitingTimes[30] * (Math.ceil(this.frontnum === 0 ? 1 : this.frontnum / 30) - 1)
						})
						this.$store.state.loading = false
						this.realWait = true
					} else {
						this.nowaitUser.show = false
					}
				})
				.catch(() => {
					this.$store.state.loading = false
					this.realWait = false
					// this.alertModal2.dialog = true
					// this.alertModal2.text = '상담 신청 내역이 없습니다'
					// this.$store.state.loading = false
				})
		},

		refresh() {
			this.$store.state.loading = true
			this.countDown = 5
			const countDown = setInterval(() => {
				this.countDown -= 1
				if (this.countDown === 0) {
					clearInterval(countDown)
				}
			}, 1000)
			this.realTimeWait()
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		close() {
			//창닫기
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
			document.getElementById('closeWaiting').click()
		},
	},
}
</script>
<style lang="scss" scoped>
html,
body,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
li,
dl,
dt,
dd,
table,
th,
td,
form,
fieldset,
legend,
input,
textarea,
button {
	font-family: 'Noto Sans KR', 'Apple SD Gothic Neo';
	margin: 0;
	padding: 0;
	letter-spacing: -1px;
}
li {
	list-style: none;
}
img,
fieldset {
	border: none;
	margin: 0;
	padding: 0;
}
</style>
